import { render, staticRenderFns } from "./relatorio-sfat.vue?vue&type=template&id=73983581&scoped=true&"
import script from "./relatorio-sfat.vue?vue&type=script&lang=js&"
export * from "./relatorio-sfat.vue?vue&type=script&lang=js&"
import style0 from "./relatorio-sfat.vue?vue&type=style&index=0&id=73983581&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73983581",
  null
  
)

export default component.exports